import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import {observer} from 'mobx-react';
import {IPreset} from '../../services/presets/preset.interface';


const styles = (theme: Theme) => createStyles ({
    preset: {
        width: '100%',
        paddingLeft: 10,
        paddingRight: 0
    }
});

export interface RegulationPresetsComponentProps extends WithStyles<typeof styles> {
    title: string;
    presets: IPreset[]
}

export const PresetsComponent = withStyles(styles)(
    observer(class extends LauncherComponentBase<RegulationPresetsComponentProps> {

        private _onApplyPreset = (preset: IPreset) => {
            preset.applyPreset();
            //this.services.body.toggleDrawer();
        };

        private _renderPreset(preset: IPreset) {
            return (
                <ListItem dense={true} key={preset.name} button onClick={() => this._onApplyPreset(preset)}>
                    <ListItemText primary={preset.name.toUpperCase()}/>
                </ListItem>)
        }

        render() {
            return (
                <ExpansionPanel defaultExpanded={true} className={this.props.classes.preset}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>} >
                        <Typography variant="button">{this.props.title}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <div className={this.props.classes.preset}>
                            <List>
                                {this.props.presets.sort((p1, p2) => p1.name < p2.name ? -1 : 1)
                                                    .map(preset => this._renderPreset(preset))}
                            </List>
                        </div>

                    </ExpansionPanelDetails>
                </ExpansionPanel>


            )
        }
    }));
